









































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItemString, PulldownItem } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class BasicInfo5 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() prefecturess!: PulldownItem[]; //都道府県コード
  @Prop() prefectures_strings!: SelectItemString[]; //都道府県コード（string版）
  @Prop() list_marks_codes!: SelectItemString[]; //点数表コード
}
